export const MAX_DESCRIPTION_LENGTH_FOR_SINGLE_LINE = 22;

export default {
  brandButton: {
    attr: {
      text: 'other.aboutBrand',
      className: 'product__brand-button',
    },
  },
};
